export const DEV_TITLE_ID = 'D8BB1';
export const PROD_TITLE_ID = '3A352';
export const TITLE_ID = PROD_TITLE_ID;

export const MONSTERWALK_DEV_TITLE_ID = '3AF51';
export const MONSTERWALK_PROD_TITLE_ID = '189B9';